import { render, staticRenderFns } from "./ProductApplicationForm.vue?vue&type=template&id=22d7afd1&scoped=true&lang=html&"
import script from "./ProductApplicationForm.vue?vue&type=script&lang=js&"
export * from "./ProductApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductApplicationForm.vue?vue&type=style&index=0&id=22d7afd1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7afd1",
  null
  
)

export default component.exports